import { DeprecatedSelect, type SelectProps } from "@octopusdeploy/design-system-octopus-components";
import type { EnvironmentResource, EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import { sortBy } from "lodash";
type SelectPropsWithoutItems = Omit<SelectProps, "items">;
interface EnvironmentSelectProps extends SelectPropsWithoutItems {
    fieldName?: string;
    environments: (EnvironmentResource | EnvironmentV2Resource)[];
}
const EnvironmentSelect = (props: EnvironmentSelectProps) => {
    const { environments, ...rest } = props;
    const sortedEnvironments = sortBy(environments, (x) => x.SortOrder).map((e) => ({ value: e.Id, text: e.Name }));
    return <DeprecatedSelect sortItems={false} items={sortedEnvironments} {...rest}/>;
};
export default EnvironmentSelect;
